
function PageLoader({ show }) {
    return (
        <>
            {show && (<div className="loading">Loading&#8230;</div>)}
        </>
    )
}

export default PageLoader